export enum StoryType {
  NftCard = 'NftCard',
  Text = 'Text',
  Sticker = 'Sticker',
  Mention = 'Mention',
  GIF = 'GIF',
  Link = 'Link',
}

export interface IStoryItem {
  id: number;
  position: {
    X: number;
    Y: number;
  };
  size: {
    X: number;
    Y: number;
  };
  type: StoryType;
  text?: string;
  url?: string;
  zIndex?: number;
}
